// Auto-generated by scripts/split_ui.js from data/adhkarPagiPetang.js — do not edit.
export const ADHKAR_UI = {
  "pageTitle": {
    "id": "Zikir Pagi & Petang",
    "en": "Morning & Evening Adhkar",
    "ar": "أذكار الصباح والمساء",
    "fr": "Invocations du matin et du soir",
    "de": "Morgen- und Abendgebete (Adhkar)",
    "es": "Adhkar de la mañana y la tarde",
    "ru": "Азкары утра и вечера",
    "zh": "晨昏祈念（早晚ذكر）",
    "ja": "朝と夕のズィクル",
    "ko": "아침 & 저녁 즈크르",
    "hi": "सुबह और शाम के अज़्कार"
  },
  "pageSub": {
    "id": "Amalan dzikir pagi dan petang lengkap sesuai sunnah Nabi ﷺ — dijalankan berurutan dengan penghitung.",
    "en": "Complete morning and evening dhikr practices in accordance with the Sunnah of the Prophet ﷺ — performed in sequence with a counter.",
    "ar": "أذكار الصباح والمساء الكاملة وفق سنة النبي ﷺ — تُؤدَّى بالترتيب مع عداد.",
    "fr": "Pratiques complètes de dhikr du matin et du soir conformément à la Sunnah du Prophète ﷺ — exécutées en séquence avec un compteur.",
    "de": "Vollständige Morgen- und Abend-Dhikr-Praktiken gemäß der Sunnah des Propheten ﷺ — der Reihe nach mit einem Zähler ausgeführt.",
    "es": "Prácticas completas de dhikr matutino y vespertino conforme a la Sunnah del Profeta ﷺ — realizadas en secuencia con un contador.",
    "ru": "Полные практики утреннего и вечернего зикра в соответствии с Сунной Пророка ﷺ — выполняются последовательно со счётчиком.",
    "zh": "完整的晨昏迪克尔，遵循先知ﷺ的逊奈——按顺序配合计数器进行。",
    "ja": "預言者ﷺのスンナに従った完全な朝と夕べのズィクル実践 — カウンター付きで順番に行います。",
    "ko": "예언자 ﷺ의 순나에 따른 완전한 아침과 저녁 디크르 실천 — 카운터와 함께 순서대로 수행합니다.",
    "hi": "नबी ﷺ की सुन्नत के अनुसार सम्पूर्ण सुबह और शाम के ज़िक्र के अमल — काउंटर के साथ क्रमबद्ध रूप से किए जाते हैं।"
  },
  "dashLabel": {
    "id": "Zikir Pagi & Petang",
    "en": "Morning & Evening Dhikr",
    "ar": "أذكار الصباح والمساء",
    "fr": "Dhikr du Matin et du Soir",
    "de": "Morgen- und Abend-Dhikr",
    "es": "Dhikr de la Mañana y la Tarde",
    "ru": "Утренний и вечерний зикр",
    "zh": "晨昏迪克尔",
    "ja": "朝と夕べのズィクル",
    "ko": "아침과 저녁 디크르",
    "hi": "सुबह और शाम का ज़िक्र"
  },
  "dashHint": {
    "id": "Dzikir harian berurutan dengan penghitung",
    "en": "Sequential daily dhikr with a counter",
    "ar": "أذكار يومية مرتبة مع عداد",
    "fr": "Dhikr quotidien séquentiel avec compteur",
    "de": "Sequenzieller täglicher Dhikr mit Zähler",
    "es": "Dhikr diario secuencial con contador",
    "ru": "Последовательный ежедневный зикр со счётчиком",
    "zh": "按顺序进行的每日迪克尔，配有计数器",
    "ja": "カウンター付きの順序ある毎日のズィクル",
    "ko": "카운터와 함께하는 순차적인 매일 디크르",
    "hi": "काउंटर के साथ क्रमबद्ध दैनिक ज़िक्र"
  },
  "morning": {
    "id": "Pagi",
    "en": "Morning",
    "ar": "الصباح",
    "fr": "Matin",
    "de": "Morgen",
    "es": "Mañana",
    "ru": "Утро",
    "zh": "晨",
    "ja": "朝",
    "ko": "아침",
    "hi": "सुबह"
  },
  "evening": {
    "id": "Petang",
    "en": "Evening",
    "ar": "المساء",
    "fr": "Soir",
    "de": "Abend",
    "es": "Tarde",
    "ru": "Вечер",
    "zh": "昏",
    "ja": "夕べ",
    "ko": "저녁",
    "hi": "शाम"
  },
  "start": {
    "id": "Mulai Berzikir",
    "en": "Begin Dhikr",
    "ar": "ابدأ الذكر",
    "fr": "Commencer le Dhikr",
    "de": "Dhikr beginnen",
    "es": "Comenzar el Dhikr",
    "ru": "Начать зикр",
    "zh": "开始迪克尔",
    "ja": "ズィクルを始める",
    "ko": "디크르 시작하기",
    "hi": "ज़िक्र शुरू करें"
  },
  "next": {
    "id": "Berikutnya",
    "en": "Next",
    "ar": "التالي",
    "fr": "Suivant",
    "de": "Weiter",
    "es": "Siguiente",
    "ru": "Далее",
    "zh": "下一步",
    "ja": "次へ",
    "ko": "다음",
    "hi": "अगला"
  },
  "prev": {
    "id": "Sebelumnya",
    "en": "Previous",
    "ar": "السابق",
    "fr": "Précédent",
    "de": "Zurück",
    "es": "Anterior",
    "ru": "Назад",
    "zh": "上一步",
    "ja": "前へ",
    "ko": "이전",
    "hi": "पिछला"
  },
  "of": {
    "id": "dari",
    "en": "of",
    "ar": "من",
    "fr": "de",
    "de": "von",
    "es": "de",
    "ru": "из",
    "zh": "/",
    "ja": "/",
    "ko": "/",
    "hi": "में से"
  },
  "tapToCount": {
    "id": "Ketuk lingkaran untuk menghitung",
    "en": "Tap the circle to count",
    "ar": "اضغط على الدائرة للعدّ",
    "fr": "Appuyez sur le cercle pour compter",
    "de": "Tippen Sie auf den Kreis zum Zählen",
    "es": "Toca el círculo para contar",
    "ru": "Нажмите на круг для подсчёта",
    "zh": "点击圆圈以计数",
    "ja": "円をタップしてカウント",
    "ko": "원을 눌러 카운트하세요",
    "hi": "गिनती के लिए वृत्त पर टैप करें"
  },
  "meaningLabel": {
    "id": "Arti",
    "en": "Meaning",
    "ar": "المعنى",
    "fr": "Signification",
    "de": "Bedeutung",
    "es": "Significado",
    "ru": "Значение",
    "zh": "含义",
    "ja": "意味",
    "ko": "의미",
    "hi": "अर्थ"
  },
  "virtueLabel": {
    "id": "Keutamaan",
    "en": "Virtue",
    "ar": "الفضيلة",
    "fr": "Vertu",
    "de": "Tugend",
    "es": "Virtud",
    "ru": "Достоинство",
    "zh": "美德",
    "ja": "美徳",
    "ko": "덕목",
    "hi": "फ़ज़ीलत"
  },
  "sourceLabel": {
    "id": "Dalil",
    "en": "Source",
    "ar": "المصدر",
    "fr": "Source",
    "de": "Quelle",
    "es": "Fuente",
    "ru": "Источник",
    "zh": "来源",
    "ja": "出典",
    "ko": "출처",
    "hi": "स्रोत"
  },
  "playBtn": {
    "id": "Dengarkan",
    "en": "Listen",
    "ar": "استمع",
    "fr": "Écouter",
    "de": "Anhören",
    "es": "Escuchar",
    "ru": "Слушать",
    "zh": "收听",
    "ja": "聴く",
    "ko": "듣기",
    "hi": "सुनें"
  },
  "shareBtn": {
    "id": "Bagikan",
    "en": "Share",
    "ar": "شارك",
    "fr": "Partager",
    "de": "Teilen",
    "es": "Compartir",
    "ru": "Поделиться",
    "zh": "分享",
    "ja": "シェア",
    "ko": "공유",
    "hi": "साझा करें"
  },
  "shareText": {
    "id": "Zikir pagi/petang dari aplikasi Manasik — Panduan Umrah & Haji ✨",
    "en": "Morning/evening Dhikr from the Manasik app — Umrah & Hajj Guide ✨",
    "ar": "أذكار الصباح والمساء من تطبيق مناسك — دليل العمرة والحج ✨",
    "fr": "Dhikr du matin/soir depuis l'application Manasik — Guide Umrah & Hajj ✨",
    "de": "Morgen-/Abend-Dhikr aus der Manasik-App — Umrah & Hajj-Leitfaden ✨",
    "es": "Dhikr de mañana/tarde desde la aplicación Manasik — Guía de Umrah y Hajj ✨",
    "ru": "Утренний/вечерний Зикр из приложения Manasik — Руководство по Умре и Хаджу ✨",
    "zh": "来自Manasik应用的晨昏迪克尔——朝觐与副朝指南 ✨",
    "ja": "ManasikアプリからのDhikr（朝・夕）— ウムラ＆ハッジガイド ✨",
    "ko": "Manasik 앱의 아침/저녁 디크르 — 우므라 & 하지 가이드 ✨",
    "hi": "Manasik ऐप से सुबह/शाम का ज़िक्र — उमरा और हज गाइड ✨"
  },
  "completeTitle": {
    "id": "Alhamdulillah, Selesai!",
    "en": "Alhamdulillah, Complete!",
    "ar": "الحمد لله، اكتملت الأذكار!",
    "fr": "Alhamdulillah, Terminé !",
    "de": "Alhamdulillah, Abgeschlossen!",
    "es": "Alhamdulillah, ¡Completado!",
    "ru": "Альхамдулиллах, завершено!",
    "zh": "阿尔罕杜里拉，完成了！",
    "ja": "アルハムドゥリッラー、完了しました！",
    "ko": "알함두릴라, 완료했습니다!",
    "hi": "अलहम्दुलिल्लाह, पूरा हुआ!"
  },
  "completeBody": {
    "id": "Anda telah menuntaskan seluruh rangkaian zikir. Semoga Allah menerima amalan Anda.",
    "en": "You have completed the entire series of Dhikr. May Allah accept your deeds.",
    "ar": "لقد أتممتَ جميع الأذكار. تقبَّل الله منك صالح الأعمال.",
    "fr": "Vous avez accompli l'intégralité des Dhikr. Qu'Allah accepte vos bonnes œuvres.",
    "de": "Sie haben die gesamte Dhikr-Reihe abgeschlossen. Möge Allah Ihre Taten annehmen.",
    "es": "Has completado toda la serie de Dhikr. Que Allah acepte tus obras.",
    "ru": "Вы завершили весь цикл Зикра. Да примет Аллах ваши благие деяния.",
    "zh": "您已完成全部迪克尔的诵读。愿安拉接受您的善功。",
    "ja": "すべてのDhikrを完了しました。アッラーがあなたの善行を受け入れてくださいますように。",
    "ko": "모든 디크르를 완료했습니다. 알라께서 당신의 선행을 받아들이시길 바랍니다.",
    "hi": "आपने सभी ज़िक्र की पूरी श्रृंखला पूरी कर ली है। अल्लाह आपके नेक आमाल को कुबूल फरमाए।"
  },
  "restart": {
    "id": "Ulangi dari Awal",
    "en": "Restart from the Beginning",
    "ar": "ابدأ من جديد",
    "fr": "Recommencer depuis le début",
    "de": "Von vorne beginnen",
    "es": "Reiniciar desde el principio",
    "ru": "Начать сначала",
    "zh": "从头开始",
    "ja": "最初からやり直す",
    "ko": "처음부터 다시 시작",
    "hi": "शुरुआत से पुनः आरंभ करें"
  },
  "backToList": {
    "id": "Lihat Semua Zikir",
    "en": "View All Adhkar",
    "ar": "عرض جميع الأذكار",
    "fr": "Voir tous les Adhkâr",
    "de": "Alle Adhkar anzeigen",
    "es": "Ver todos los Adhkār",
    "ru": "Просмотреть все Азкары",
    "zh": "查看所有记忆词",
    "ja": "すべてのアズカールを見る",
    "ko": "모든 아즈카르 보기",
    "hi": "सभी अज़कार देखें"
  },
  "autoAdvance": {
    "id": "Lanjut otomatis saat target tercapai",
    "en": "Auto-advance when target is reached",
    "ar": "التقدم التلقائي عند بلوغ الهدف",
    "fr": "Avancer automatiquement lorsque l'objectif est atteint",
    "de": "Automatisch weiter, wenn das Ziel erreicht ist",
    "es": "Avanzar automáticamente al alcanzar el objetivo",
    "ru": "Автоматический переход при достижении цели",
    "zh": "达到目标时自动前进",
    "ja": "目標達成時に自動で次へ進む",
    "ko": "목표 달성 시 자동으로 넘어가기",
    "hi": "लक्ष्य पूरा होने पर स्वतः आगे बढ़ें"
  }
};
